site.megamenu = {
	init:function() {
		var $body = $('body');
		var $mainmenu = $('#mainmenu');
		if ($(document).width()+15 >= 992) {
			$('.mmLevel2', $mainmenu).wrap('<div class="megamenu"></div>');
			$('.megamenu').append('<div class="extra entryContent" />');
		}

		$('.level1.children > a',$mainmenu).on('click touchstart', function (e) {
			if ($(document).width()+15 >= 992) {
				e.preventDefault();
				e.stopPropagation();

				//Click on node that is already open
				if ($(this).parent().hasClass('open')) {
					site.megamenu.close();
				}
				//Open megamenu
				else {
					// site.headSearch.close(true);
					$('.level1.open', $mainmenu).removeClass('open');
					$('.megamenu', $mainmenu).removeAttr('style');
					$(this).parent().addClass('open');

					if (!$body.hasClass('megamenu-open')) {
						$body.addClass('megamenu-opening');

						setTimeout(function() {
							$body.removeClass('megamenu-opening');
							if (!$body.is('.megamenu-closing')) {
								$body.addClass('megamenu-open');
							}
						},400);
					}
				}
			}
		});

		$('.mmLevel2 > .si > a',$mainmenu).on('mouseenter focus', function() {
			$('body').removeClass('level3-open');
			$('.mmLevel3').removeClass('open');
			var $li = $(this).closest('li');
			site.megamenu.getExtraContents($li);
		});

		$('.level2.children > a', $mainmenu).on('mouseenter focus', function (e) {
			if ($(document).width()+15 >= 992) {
				e.preventDefault();
				e.stopPropagation();

				$('.mmLevel3').removeClass('open');
				$('.level3 > a').removeClass('selected');
				$(this).siblings('.mmLevel3').addClass('open');
				$(this).siblings('.mmLevel3').addClass('selected');
				$('body').addClass('level3-open');
			}
		});

		$(document).on('click touchstart', function(e)
		{
			if ($('body').is('.megamenu-open')) {
				var container = $(".megamenu");

				if (!container.is(e.target) && container.has(e.target).length === 0) {
					site.megamenu.close();
				}
			}
		});

		$(document).keyup(function(e) {
			if (e.key === "Escape") { // escape key maps to keycode `27`
				site.megamenu.close();
			}
		});

		site.megamenu.loadExtraContents();
	},

	close:function() {
		var $body = $('body'),
			$mainmenu = $('#mainmenu');
		$('.level1.open', $mainmenu).removeClass('open');
		$('#pageContainer').removeAttr('style');

		if ($body.hasClass('megamenu-open')) {
			$body.addClass('megamenu-closing');
			setTimeout(function() {
				$body.removeClass('megamenu-closing');
				$('.mmLevel3').removeClass('open');
				$('body').removeClass('level3-open');
			},400);
		}
		$body.removeClass('megamenu-open');
	},

	currentContent: null,
	extraContents: null,
	loadExtraContents: function() {
		if (!site.megamenu.extraContents) {
			$.ajax({
				type: 'GET',
				'url': '/_/moya/html/ajax/sitemapExtra/',
				'dataType': 'json',
				success: function (r) {
					site.megamenu.extraContents = r;
				},
				complete: function () {
					$('.mmLevel1 >.children').each(function () {
						site.megamenu.getExtraContents($(this));
					});
				}
			});
		}
		return site.megamenu.extraContents;
	},

	getExtraContents: function($node) {
		var content = site.megamenu.extraContents[site.megamenu.getSelectorFromNode($node)];
		if (!content) {
			var $parent = $node.closest('.level1');
			content = site.megamenu.extraContents[site.megamenu.getSelectorFromNode($parent)];
		}
		var $extra = $node.closest('.megamenu').find('.extra');
		if ($extra.length === 0) {
			$extra = $node.find('.extra');
		}
		if(content !== site.megamenu.currentContent){
			$extra.addClass('hideMe');
			$extra.css('opacity', 0).css('transform', 'translateY(-10px)');
			setTimeout(function() {
				$extra.html(content);
				$extra.removeAttr('style');
			},300);
			site.megamenu.currentContent = content;
		}
	},

	getSelectorFromNode: function($node) {
		var classes = $node.attr('class'),
			codename = classes.match(/\bele\-([^\s]+)/)[1],
			level = classes.match(/level([0-9])/)[1],
			division = $('body').data('division');
		return division + '-' + codename + '-' + (parseInt(level) + 1);
	}
};

site.inits.push('site.megamenu.init()');
